<template>
  <div class="commodityEvaluate">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>商品</el-breadcrumb-item>
      <el-breadcrumb-item>评价</el-breadcrumb-item>
      <el-breadcrumb-item>评价管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="search-container">
      <el-form :inline="true" :model="customerGroupForm" class="demo-form-inline">
        <el-form-item label="评分">
          <el-select v-model="customerGroupForm.search_score" placeholder="请选择">
            <el-option label="1星" :value="1"></el-option>
            <el-option label="2星" :value="2"></el-option>
            <el-option label="3星" :value="3"></el-option>
            <el-option label="4星" :value="4"></el-option>
            <el-option label="5星" :value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="显示状态">
          <el-select v-model="customerGroupForm.search_status" placeholder="请选择">
            <el-option label="启用" :value="1"></el-option>
            <el-option label="禁用" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发布日期">
          <el-date-picker
            v-model="customerGroupForm.dataTime"
            type="daterange"
            align="right"
            unlink-panels
            @change="getTimes"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy/MM/dd"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input placeholder="请输入商品名称" v-model="customerGroupForm.search_goods_name"> </el-input>
        </el-form-item>
        <el-form-item label="关键字" class="keyword">
          <el-input placeholder="请输入内容" v-model="customerGroupForm.search_keyword"> </el-input>
        </el-form-item>
      </el-form>
      <div class="btn mg-t-10">
        <el-button type="primary" size="medium" @click="getList">查询</el-button>
        <el-button size="medium" @click="clear">清空</el-button>
      </div>
    </div>
    <div class="dataTable">
      <div style="display: flex; flex-direction: row; justify-content: space-between">
        <div class="mg-b-20">
          <el-button type="primary" size="mini" @click="onEvaluate({})">新建评价</el-button>
          <!-- 
          <el-button type="primary" size="mini" @click="getList">评价公用管理</el-button> -->
        </div>
        <div class="text-right mg-b-20">
          <span>是否允许用户评论</span>
          <el-switch
            class="mg-l-20"
            v-model="able_comment"
            active-value="1"
            inactive-value="2"
            @change="isComment"
            active-color="#13ce66"
            inactive-color="gray"
          >
          </el-switch>
        </div>
      </div>
      <el-table ref="multipleTable" :data="tableData.data" border tooltip-effect="dark" style="width: 100%">
        <el-table-column label="商品描述" :align="'center'" width="260">
          <template slot-scope="scope">
            <div class="nickAndAvatar">
              <el-image v-if="scope.row.goods.image.length > 0" :src="scope.row.goods.image[0].image"></el-image>
              <div style="width: 200px">
                <el-tooltip :content="scope.row.goods.name" placement="top">
                  <p class="ellipsis">
                    {{ scope.row.goods.name }}
                  </p>
                </el-tooltip>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="商家回复" prop="replies" :align="'center'">
          <template slot-scope="scope">
            <span v-if="scope.row.replies && scope.row.replies.length > 0">
              {{ scope.row.replies[0].content }}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="商品评分" prop="times" :align="'center'" width="200">
          <template slot-scope="scope">
            <div class="flex align-center">
              <p>质量：</p>
              <el-rate v-model="scope.row.score" score-template="{scope.row.score}" disabled :colors="colors"> </el-rate>
            </div>
            <div class="flex align-center">
              <p>服务：</p>
              <el-rate v-model="scope.row.score_service" score-template="{scope.row.score_service}" disabled :colors="colors"> </el-rate>
            </div>
            <div class="flex align-center">
              <p>推荐：</p>
              <el-rate v-model="scope.row.score_recommend" score-template="{scope.row.score_recommend}" disabled :colors="colors"> </el-rate>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="rate"
          label="好评率"
          :align="'center'"
          sortable
          width="150"
          >
        </el-table-column> -->
        <el-table-column prop="phone" label="客户" :align="'center'" width="200">
          <template slot-scope="scope">
            <router-link :to="'/customerInfo?uuid=' + scope.row.user.uuid">
              <div style="margin: 0 auto; width: 150px">
                <div class="flex align-center">
                  <el-image fit="cover" v-if="scope.row.user.avatar != null && scope.row.user.avatar != ''" :src="scope.row.user.avatar"></el-image>
                  <div class="text-left">
                    <p>{{ scope.row.user.nick_name }}</p>
                    <p>{{ scope.row.user.mobile }}</p>
                  </div>
                </div>
              </div>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="是否显示" :align="'center'">
          <template slot-scope="scope">
            <span style="color: #2ed477" v-if="scope.row.status == 1">显示</span>
            <span v-else>不显示</span>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="发布时间" :align="'center'" sortable width="160"> </el-table-column>
        <el-table-column label="操作" :align="'center'" width="250" fixed="right">
          <template slot-scope="scope">
            <div>
              <div>
                <el-button v-if="scope.row.replies && scope.row.replies.length > 0" type="text" @click="onSeller(scope.row)">
                  商家回复修改
                </el-button>
                <el-button v-else type="text" @click="onSeller(scope.row)">商家回复添加</el-button>
                <el-button type="text" @click="onSeller(scope.row, 0)" :disabled="!scope.row.replies || scope.row.replies.length == 0" :link="true">
                  删除商家回复
                </el-button>
              </div>
              <div>
                <el-button type="text" v-if="scope.row.is_top == 2" @click="toTop(scope.row)">置顶</el-button>
                <el-button type="text" v-if="scope.row.is_top == 1" @click="toTop(scope.row)">取消置顶</el-button>
                <el-button type="text" @click="checkInfo(scope.row)">评价详情</el-button>
                <el-button type="text" @click="$router.push('/orderInfo?uuid=' + scope.row.order_uuid)">订单详情</el-button>
                <el-button type="text" v-if="scope.row.status == 1" @click="showOrHide(scope.row)">隐藏</el-button>
                <el-button type="text" v-else @click="showOrHide(scope.row)">显示</el-button>
                <el-button type="text" @click="deleteEvaluate(scope.row)">删除</el-button>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total="tableData.total"
        :per_page="tableData.per_page"
        :current_page="tableData.current_page"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </div>
    <el-dialog title="评价详情" :visible.sync="dialogVisible" width="30%">
      <div class="dialogs" v-if="Object.keys(commentInfo).length > 0">
        <div class="flex space-between">
          <div class="flex avatar" style="flex: 1">
            <el-image class="img" v-if="commentInfo.images.length > 0" :src="commentInfo.images[0].url"></el-image>
            <div class="mg-l-10">
              <p>{{ commentInfo.user.nick_name }}</p>
              <p class="font-10 color-999">{{ commentInfo.create_time }}</p>
            </div>
          </div>
          <div>
            <p class="text-right">{{ commentInfo.score }}</p>
            <el-rate v-model="commentInfo.score" score-template="{commentInfo.score}" disabled :colors="colors"> </el-rate>
          </div>
        </div>
        <p class="font-12 mg-t-10 mg-b-10" v-html="commentInfo.content"></p>

        <div class="imgs">
          <el-image fit="cover" class="commentImg mg-r-10" v-for="item in commentInfo.images" :key="item" :src="item.url"></el-image>
        </div>

        <p class="font-12 color-666 mg-t-10">商品:{{ commentInfo.goods.name }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="商家回复" :visible.sync="sellerVisible" width="50%">
      <el-form :model="sellerForm" label-width="80px">
        <el-form-item label="回复内容">
          <el-input type="textarea" placeholder="请输入内容" :rows="10" v-model="sellerForm.content"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="sellerVisible = false">取消</el-button>
        <el-button size="mini" type="primary" @click="onSellerSubmit()">确定</el-button>
      </span>
    </el-dialog>
    <evaluate-dialog ref="editRef" @success="getList()" />
  </div>
</template>
<script>
  import pagination from "../../../components/pagination.vue";
  import EvaluateDialog from "./evaluateDialog.vue";
  export default {
    name: "commodityEvaluate",
    components: {
      pagination,
      EvaluateDialog,
    },
    data() {
      return {
        able_comment: "1",
        colors: ["#99A9BF", "#F7BA2A", "#FF9900"],
        customerGroupForm: {
          search_keyword: "",
          search_goods_name: "",
          search_start_time: "",
          search_end_time: "",
          search_status: "",
          search_score: "",
        },
        dialogVisible: false,
        commentInfo: {},
        value: 5,
        pickerOptions: {
          shortcuts: [
            {
              text: "今天",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(
                  start.getTime() -
                    start.getHours() * 60 * 60 * 1000 -
                    start.getMinutes() * 60 * 1000 -
                    start.getSeconds() * 1000 -
                    start.getMilliseconds()
                );
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "昨天",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(
                  start.getTime() -
                    3600 * 1000 * 24 * 1 -
                    start.getHours() * 60 * 60 * 1000 -
                    start.getMinutes() * 60 * 1000 -
                    start.getSeconds() * 1000 -
                    start.getMilliseconds()
                );
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近一周",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(
                  start.getTime() -
                    3600 * 1000 * 24 * 7 -
                    start.getHours() * 60 * 60 * 1000 -
                    start.getMinutes() * 60 * 1000 -
                    start.getSeconds() * 1000 -
                    start.getMilliseconds()
                );
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近一个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(
                  start.getTime() -
                    3600 * 1000 * 24 * 30 -
                    start.getHours() * 60 * 60 * 1000 -
                    start.getMinutes() * 60 * 1000 -
                    start.getSeconds() * 1000 -
                    start.getMilliseconds()
                );
                picker.$emit("pick", [start, end]);
              },
            },
          ],
        },
        imgs: [
          "https://axure-file.lanhuapp.com/06b9f5b8-0544-41f9-bee3-1322615ce006__84f78bae4cddf5a665809315656f99cf.svg",
          "https://axure-file.lanhuapp.com/06b9f5b8-0544-41f9-bee3-1322615ce006__21adab465da8deb8b27e917559e883b4.svg",
          "https://axure-file.lanhuapp.com/06b9f5b8-0544-41f9-bee3-1322615ce006__a74ba5d381c943891f0908d7dc409adb.svg",
        ],
        tableData: {
          data: [],
          per_page: 10,
          current_page: 1,
        },
        //卖家服务
        sellerVisible: false,
        sellerForm: {},
      };
    },
    created() {
      this.getList();
      this.getSet();
    },
    methods: {
      getSet() {
        this.axios({
          method: "get", //请求方法
          headers: {
            "Content-Type": "application/json",
            "X-Access-Token": this.storage.get("__token"),
            Authorization: `Bearer ${this.storage.get("__token")}`,
          },

          url: ` https://time.api.boyalife.cn/v1/cms/GoodsSetting/1`,
        })
          .then((res) => {
            console.log(res);
            this.able_comment = res.data.result.able_comment;
          })
          .catch((err) => {
            this.$message.error(err.response.data.error.message);
          });
      },
      // 选择时间
      getTimes(v) {
        this.customerGroupForm.search_start_time = v[0] + " 00:00:00";
        this.customerGroupForm.search_end_time = v[1] + " 23:59:59";
      },
      clear() {
        for (let i in this.customerGroupForm) {
          this.customerGroupForm[i] = "";
        }
        this.getList();
      },
      checkInfo(row) {
        this.dialogVisible = true;
        this.commentInfo = row;
        console.log(row);
      },
      // 是否允许用户评论
      isComment() {
        this.axios({
          method: "put", //请求方法
          headers: {
            "Content-Type": "application/json",
            "X-Access-Token": this.storage.get("__token"),
            Authorization: `Bearer ${this.storage.get("__token")}`,
          },
          data: {
            able_comment: this.able_comment,
          },
          url: ` https://time.api.boyalife.cn/v1/cms/GoodsSetting/1`,
        })
          .then((res) => {
            this.$message.success("设置成功！");
            this.getSet();
          })
          .catch((err) => {
            this.$message.error(err.response.data.error.message);
          });
      },
      getInfo(uuid) {
        this.axios({
          method: "get", //请求方法
          headers: {
            "Content-Type": "application/json",
            "X-Access-Token": this.storage.get("__token"),
            Authorization: `Bearer ${this.storage.get("__token")}`,
          },
          url: ` https://time.api.boyalife.cn/v1/cms/GoodsComment/${uuid}`,
        })
          .then((res) => {
            console.log(res);
          })
          .catch((err) => {
            this.$message.error(err.response.data.error.message);
          });
      },
      // 置顶
      toTop(row) {
        let isTop = row.is_top == 1 ? 2 : 1;
        this.axios({
          method: "put", //请求方法
          headers: {
            "Content-Type": "application/json",
            "X-Access-Token": this.storage.get("__token"),
            Authorization: `Bearer ${this.storage.get("__token")}`,
          },
          data: {
            is_top: isTop,
          },
          url: ` https://time.api.boyalife.cn/v1/cms/GoodsComment/top/${row.uuid}`,
        }).then((res) => {
          this.$message.success("操作成功！");
          this.getList();
        });
      },
      showOrHide(row) {
        this.axios({
          method: "put", //请求方法
          headers: {
            "Content-Type": "application/json",
            "X-Access-Token": this.storage.get("__token"),
            Authorization: `Bearer ${this.storage.get("__token")}`,
          },
          data: {
            status: row.status == 1 ? 2 : 1,
          },
          url: ` https://time.api.boyalife.cn/v1/cms/GoodsComment/status/${row.uuid}`,
        }).then((res) => {
          this.$message.success("操作成功！");
          this.getList();
        });
      },
      getList() {
        this.axios({
          method: "get", //请求方法
          headers: {
            "Content-Type": "application/json",
            "X-Access-Token": this.storage.get("__token"),
            Authorization: `Bearer ${this.storage.get("__token")}`,
          },
          url: ` https://time.api.boyalife.cn/v1/cms/GoodsComment?page_size=${this.tableData.per_page}&page_index=${this.tableData.current_page}&search_keyword=${this.customerGroupForm.search_keyword}&search_goods_name=${this.customerGroupForm.search_goods_name}&search_start_time=${this.customerGroupForm.search_start_time}&search_end_time=${this.customerGroupForm.search_end_time}&search_status=${this.customerGroupForm.search_status}&search_score=${this.customerGroupForm.search_score}`,
        })
          .then((res) => {
            this.tableData = res.data.result;
          })
          .catch((err) => {
            this.$message.success(err);
          });
      },
      deleteEvaluate(row) {
        this.$confirm("确定删除该评价吗?", "删除提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.axios({
              method: "delete", //请求方法
              headers: {
                "Content-Type": "application/json",
                "X-Access-Token": this.storage.get("__token"),
                Authorization: `Bearer ${this.storage.get("__token")}`,
              },
              url: ` https://time.api.boyalife.cn/v1/cms/GoodsComment/${row.uuid}`,
            })
              .then((res) => {
                this.$message.success("操作成功！");
                this.getList();
              })
              .catch((err) => {
                this.$message.success(err);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      },
      handleSizeChange(v) {
        this.tableData.per_page = v;
        this.getList();
      },
      handleCurrentChange(v) {
        this.tableData.current_page = v;
        this.getList();
      },
      request(method, path, data) {
        return this.axios({
          method: method, //请求方法
          data,
          headers: {
            "Content-Type": "application/json",
            "X-Access-Token": this.storage.get("__token"),
            Authorization: `Bearer ${this.storage.get("__token")}`,
          },
          url: ` https://time.api.boyalife.cn/v1/cms/${path}`,
        });
      },
      onRemoveSeller(row = {}) {
        const replies = row.replies;
        if (replies && replies.length > 0) {
          this.$confirm("确定删除该商家回复评价吗?", "删除提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.request("delete", `GoodsCommentReply/${replies[0].uuid}`, {})
                .then(() => {
                  this.sellerVisible = false;
                  this.$message.success("操作成功！");
                  this.getList();
                })
                .catch((err) => this.$message.success(err));
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除",
              });
            });
        }
      },
      onSeller(row = {}, type) {
        if (type === 0) {
          this.onRemoveSeller(row);
          return;
        }
        const { content, uuid } = row.replies && row.replies.length > 0 ? row.replies[0] : {};
        this.sellerForm = {
          ...row,
          replies_uuid: uuid,
          content: content || "",
        };
        this.sellerVisible = true;
      },
      onSellerSubmit() {
        const { replies_uuid, uuid, content } = this.sellerForm;
        if (replies_uuid) {
          const params = {
            content,
          };
          this.request("put", `GoodsCommentReply/${replies_uuid}`, params)
            .then((res) => {
              this.sellerVisible = false;
              this.$message.success("操作成功！");
              this.getList();
            })
            .catch((err) => {
              this.$message.success(err);
            });
          return;
        }
        const params = {
          content,
          comment_uuid: uuid,
        };
        this.request("post", "GoodsCommentReply", params)
          .then((res) => {
            this.sellerVisible = false;
            this.$message.success("操作成功！");
            this.getList();
          })
          .catch((err) => {
            this.$message.success(err);
          });
      },
      //评价编辑
      onEvaluate(row = {}) {
        this.$refs.editRef.open(row);
      },
    },
  };
</script>
<style scoped>
  .customerGroupList {
    background: #f2f2f2;
  }
  .avatar .img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  .search-container {
    padding: 20px;
    background: #fff;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    font-size: 12px !important;
  }
  >>> .el-input-group {
    width: 400px;
  }
  .ellipsis {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    height: 50px;
    max-height: 50px;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
  }
  .commodityEvaluate .el-table .product .el-image {
    width: 60px;
    height: auto;
    border-radius: 0 !important;
  }
  >>> .el-button--text {
    padding: 5px 0px;
  }
  >>> .el-button--text span {
    font-size: 12px;
  }
  >>> .el-dialog__body {
    padding: 20px;
  }
  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  .dialogs .imgs {
    padding: 20px 0;
  }
  .imgs .commentImg {
    width: 104px;
    height: 86px;
    border-radius: 8px;
  }
</style>
